/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
import { NamedNode } from '../models.js';
import { Prefix } from '../utils/Prefix.js';
var base = 'http://www.w3.org/2001/XMLSchema#';
export var _ontologyResource = NamedNode.getOrCreate(base);
Prefix.add('xsd', base);
var string = NamedNode.getOrCreate(base + 'string');
var boolean = NamedNode.getOrCreate(base + 'boolean');
var date = NamedNode.getOrCreate(base + 'date');
var integer = NamedNode.getOrCreate(base + 'integer');
var float = NamedNode.getOrCreate(base + 'float');
var double = NamedNode.getOrCreate(base + 'double');
var time = NamedNode.getOrCreate(base + 'time');
var duration = NamedNode.getOrCreate(base + 'duration');
var decimal = NamedNode.getOrCreate(base + 'decimal');
var gYear = NamedNode.getOrCreate(base + 'gYear');
var Bytes = NamedNode.getOrCreate(base + 'Bytes');
var long = NamedNode.getOrCreate(base + 'long');
var dateTime = NamedNode.getOrCreate(base + 'dateTime');
//not yet required by core so why define it?
//export var boolean:NamedNode = nodes.getOrCreate(base+"boolean");
export const xsd = {
    _ontologyResource,
    string,
    boolean,
    date,
    integer,
    float,
    double,
    time,
    duration,
    decimal,
    gYear,
    Bytes,
    long,
    dateTime,
};
//# sourceMappingURL=xsd.js.map